import { Button, Card, Flex } from 'antd';
import NumberElement from 'components/number/number';
import Riyal from 'components/riyal/riyal';
import { isRTL } from 'core/services/language';
import { Plan } from 'modules/main/auth/register/models/plans';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import Icon from 'utils/icon';
import styles from './plan.module.scss';
import PriceElement from 'components/price/price';

interface PlanComponentProps {
	plan: Plan;
	bordered?: boolean;
	centered?: boolean;
	onChoosePlan: (plan: Plan) => void;
	disabled?: boolean;
}

const PlanComponent: FunctionComponent<PlanComponentProps> = ({ plan, bordered = true, disabled, onChoosePlan }) => {
	const { t } = useTranslation();

	return (
		<Card className={styles.plan} style={{ minWidth: 300 }}>
			<Flex vertical justify="space-between" className={`h-100`}>
				<div>
					<img src={plan.icon} style={{ display: 'block', margin: 'auto', width: 60, height: 60 }} />
					<h4 className="mt-3 text-center">{isRTL() ? plan.translated_title.ar : plan.translated_title.en}</h4>
					{plan.is_free ? (
						<>
							<div className={`d-flex align-items-baseline gap-2 mt-4 justify-content-center`}>
								<h1 className="fw-semibold" style={{ fontSize: '3rem' }}>
									{t('REGISTER.FREE')}
								</h1>
							</div>
							<h6 className="text-center">
								{t('REGISTER.PAID_FEATURES')} / {t('REGISTER.UNLIMITED')}
							</h6>
						</>
					) : (
						<>
							<PriceElement
								value={+plan.price}
								containerStyle={{ display: 'flex', justifyContent: 'center' }}
								fontSize="3rem"
								fontStyle={{ fontWeight: 600 }}
								riyalSize="2.4rem"
							/>

							<h6 className="text-center">{t('REGISTER.ANNUALLY')}</h6>
						</>
					)}

					<div className="mt-5">
						{plan.features.map((feature, index) => (
							<Flex align="center" gap={20} className="mb-2" key={index}>
								<Icon name="check" />
								<span>{isRTL() ? feature.translated_title.ar : feature.translated_title.en}</span>
							</Flex>
						))}
					</div>
				</div>

				<Button className={styles.planBtn} onClick={(e) => onChoosePlan(plan)} disabled={disabled}>
					{t('REGISTER.START_NOW')}
				</Button>
			</Flex>
		</Card>
	);
};

export default PlanComponent;
